import type { ReactNode } from 'react'
import type { Project } from '../types'

import { Bezel } from '../bezel'
import { PROJECTS } from '../data'
import { useDesk95Theme } from '../theme'

type PhotoshopProps = {
    isMobile: boolean
    onOpenProject: (project: Project) => void
}

export const Photoshop = ({ isMobile, onOpenProject }: PhotoshopProps): ReactNode => {
    const palette = useDesk95Theme()

    return (
        <div className='flex size-full flex-col' style={{ background: palette.face }}>
            <Bezel
                variant='sunken'
                face={false}
                className='desk95-scroll m-[3px] min-h-0 flex-1 overflow-y-auto p-[10px]'
                style={{ background: palette.surface }}
            >
                <p className='mb-[10px] text-[11px]' style={{ color: palette.surfaceText }}>
                    Contact sheet &mdash; {PROJECTS.length} documents. Double-click a thumbnail to open it.
                </p>

                <ul className='grid grid-cols-[repeat(auto-fill,minmax(112px,1fr))] gap-[16px] pr-[6px] pb-[10px]'>
                    {PROJECTS.map(project => (
                        <li key={project.id}>
                            <button
                                type='button'
                                className='block w-full text-left'
                                style={{ cursor: 'default' }}
                                onDoubleClick={() => onOpenProject(project)}
                                onClick={() => isMobile && onOpenProject(project)}
                                aria-label={`Open ${project.file}`}
                            >
                                <span
                                    className='block bg-white p-[4px]'
                                    style={{
                                        border: '3px solid #000000',
                                        boxShadow: `6px 6px 0 0 ${palette.shadow}`
                                    }}
                                >
                                    <img
                                        src={project.image}
                                        alt={project.alt}
                                        className='block aspect-square w-full object-cover'
                                        draggable={false}
                                    />
                                </span>

                                <span
                                    className='mt-[10px] block truncate text-[11px] leading-none'
                                    style={{ color: palette.surfaceText }}
                                >
                                    {project.file}
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            </Bezel>

            <div className='flex shrink-0 gap-[3px] px-[3px] pb-[3px]'>
                <Bezel variant='sunken' thin className='flex-1 px-[5px] py-[2px] text-[11px] leading-none'>
                    {PROJECTS.length} document(s)
                </Bezel>

                <Bezel variant='sunken' thin className='px-[5px] py-[2px] text-[11px] leading-none'>
                    RGB / 8 bit
                </Bezel>
            </div>
        </div>
    )
}
